module.exports = __webpack_public_path__ + "static/media/checked_light.0c40f644.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/SRA/checked_light.png
// module id = 3531
// module chunks = 3